import script from "./SoundEngine.vue?vue&type=script&setup=true&lang=js"
export * from "./SoundEngine.vue?vue&type=script&setup=true&lang=js"

import "./SoundEngine.vue?vue&type=style&index=0&id=2c096120&scoped=true&lang=css"

import exportComponent from "/Users/bruno/Documents/Codex/bam4-share-link-work/bam4-master/client/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c096120"]])

export default __exports__